// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__epuQr","valueOn":"Progress_valueOn__efkTE","valueOff":"Progress_valueOff__BLcZU"};